import "../../App.css";
import splash from "../../img/splash.jpg";
import slider1 from "../../img/bg8.jpg";
import slider2 from "../../img/splash.jpg";
import slider3 from "../../img/bg10.jpg";
import slider4 from "../../img/bg9.jpg";
import { Carousel, CarouselItem } from "reactstrap";
import { useEffect, useState } from "react";
const items = [0, 1, 2, 3];

function Home({ handleClick, opening, msg }) {
  const [activeIndex, setActiveIndex] = useState(2);
  const [animating, setAnimating] = useState(false);
  const next = () => {
    if (animating) return;
    const nextIndex = activeIndex === items.length - 1 ? 0 : activeIndex + 1;
    setActiveIndex(nextIndex);
  };

  const previous = () => {
    if (animating) return;
    const nextIndex = activeIndex === 0 ? items.length - 1 : activeIndex - 1;
    setActiveIndex(nextIndex);
  };

  useEffect(() => {
    next();
  }, []);
  return (
    <section id="splash" className="step color--color1">
      <div className="wraper_slider ">
        <Carousel
          fade={true}
          interval={2000}
          activeIndex={activeIndex}
          next={next}
          previous={previous}
          className=""
        >
          <CarouselItem
            className="img_slider"
            onExiting={() => setAnimating(true)}
            onExited={() => setAnimating(false)}
            key={1}
          >
            <img className="carousel-img" src={slider1} alt="" />
          </CarouselItem>
          <CarouselItem
            className="img_slider"
            onExiting={() => setAnimating(true)}
            onExited={() => setAnimating(false)}
            key={2}
          >
            <img className="carousel-img" src={slider2} alt="" />
          </CarouselItem>
          <CarouselItem
            onExiting={() => setAnimating(true)}
            onExited={() => setAnimating(false)}
            key={3}
            className="img_slider"
          >
            <img className="carousel-img" src={slider3} alt="" />
          </CarouselItem>
          <CarouselItem
            onExiting={() => setAnimating(true)}
            onExited={() => setAnimating(false)}
            key={4}
            className="img_slider"
          >
            <img className="carousel-img" src={slider4} alt="" />
          </CarouselItem>

          {/*slides*/}
        </Carousel>
      </div>

      <div className="in">
        <main>
          {!opening ? (
            <>
              <div className="msgbox">
                <p
                  className={
                    msg.length > 300
                      ? "opening home_subtitle medium text--uppercase msg size2"
                      : "opening home_subtitle medium text--uppercase msg"
                  }
                >
                  {" "}
                  {msg
                    ? msg
                    : "¡Gracias por preferirnos! Nuestro simulador ya ha finalizado su proceso, te esperamos para la Admisión 2024, ¡nos vemos! TKM :D"}
                </p>
              </div>
            </>
          ) : (
            <>
              <div className="ttl padded--right title_wrap">
                <h2 className="huge titular title-main title_flex">
                  <span className="home_subtitle subtitle_1">
                    {" "}
                    Una nueva carrera para{" "}
                  </span>
                  <span className="home_subtitle subtitle_2">
                    {" "}
                    transformar tu futuro
                  </span>
                </h2>
                <div
                  style={{ marginTop: "2rem", color: "#039" }}
                  className=" home_subtitle titular medium text--uppercase"
                >
                  Simula tu beneficio y postula a Advance
                </div>
                <div className="button submit style--10 padding--left">
                  <button
                    id="start"
                    className="init_button"
                    onClick={handleClick}
                  >
                    <strong>Comienza ahora</strong>
                  </button>
                </div>
              </div>
            </>
          )}
        </main>
      </div>
    </section>
  );
}

export default Home;
